import './content-templates-view/content-templates-view.component';
import './content-templates-view/content-templates-view.scss';

import './content-templates-table/content-templates-table.component';
import './content-templates-table/content-templates-table.scss';

import './content-templates-table-row/content-templates-table-row.component';
import './content-templates-table-row/content-templates-table-row.scss';

import './content-template-create-view/content-template-create-view.component';
import './content-template-create-view/content-template-create-view.scss';

import './content-template-select/content-template-select.component';
import './content-template-select/content-template-select.scss';

import './content-template-select-list/content-template-select-list.component';
import './content-template-select-list/content-template-select-list.scss';
